import React from "react";

// Logo principal (texto oscuro) — para fondos claros (header)
const LOGO_URL_LIGHT_BG =
  "https://customer-assets.emergentagent.com/job_cotiza-ahora/artifacts/8hb3rbcf_Captura_de_pantalla_2026-05-13_a_la_s__17.02.49-removebg-preview.png";

// Logo invertido (texto blanco) — para fondos oscuros (footer)
const LOGO_URL_DARK_BG =
  "https://customer-assets.emergentagent.com/job_cotiza-ahora/artifacts/fvyoh7tu_ChatGPT_Image_13_may_2026__17_38_44-removebg-preview.png";

const CORFO_LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_cotiza-ahora/artifacts/095486c9df3379f5_logo-corfo-1.webp";

/**
 * Brand logo lockup.
 * - variant="default" → logo oscuro sobre superficies claras (header)
 * - variant="light"   → logo blanco sobre superficies oscuras (footer)
 *
 * imgClassName allows responsive sizing (e.g. "h-10 md:h-16").
 * If not provided, falls back to the `size` prop (numeric height in px).
 */
export function BrandLogo({ size = 40, variant = "default", subline, corfo = false, className = "", imgClassName, ...props }) {
  const isLight = variant === "light";
  const src = isLight ? LOGO_URL_DARK_BG : LOGO_URL_LIGHT_BG;

  const logoEl = imgClassName ? (
    <img
      src={src}
      alt="Mi Comunidad Segura"
      className={`w-auto block ${imgClassName}`}
      draggable={false}
    />
  ) : (
    <img
      src={src}
      alt="Mi Comunidad Segura"
      style={{ height: size, width: "auto", display: "block" }}
      draggable={false}
    />
  );

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} {...props}>
      {logoEl}
      {subline && (
        <div className="leading-tight ml-1 hidden md:block">
          <div
            className="text-[9.5px] uppercase tracking-[0.22em] font-semibold"
            style={{ color: isLight ? "rgba(255,255,255,0.6)" : "var(--text-muted)" }}
          >
            {subline}
          </div>
          {corfo && (
            <div className="flex items-center gap-1.5 mt-1" data-testid="corfo-support">
              <span
                className="text-[8px] uppercase tracking-[0.14em] font-semibold whitespace-nowrap"
                style={{ color: isLight ? "rgba(255,255,255,0.55)" : "var(--text-muted)" }}
              >
                Empresa apoyada por
              </span>
              <img src={CORFO_LOGO_URL} alt="CORFO" className="h-[13px] w-auto" draggable={false} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default BrandLogo;
